import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Grow } from '@material-ui/core'

const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 100px;
  width: ${props => props.radius ?? 140}px;
  height: ${props => props.radius ?? 140}px;
  > * {
    width: 50%;
  }
`
const StyledBox = styled(Box)`
  h2 {
    margin-top: px;
    color: ${(props) => props.theme.colors.primary.main};
    color: white;
    div {
      width: 22px;
      display: inline-block;
      text-align: center;
    }
  }

  p {
    max-width: 300px;
    color: white;
    text-align: center;
    margin-top: 50px;
    font-size: 2.0rem;
    font-weight: 500
  }

  @media (min-width: 600px) {
    h2 {
      div {
        width: 39px;
      }
    }
  }
`

const EmoticonCaptionCard = ({ timeout, image, subTitle, radius }) => {
  const transitionIn = true
  return (
    <Grow in={transitionIn} timeout={1000 + timeout}>
      <StyledBox
        // ref={ref}
        display='flex'
        flexDirection='column'
        alignItems='center'
      >
        <Circle radius={radius}>{image}</Circle>
        <p>{subTitle}</p>
      </StyledBox>
    </Grow>
  )
}

EmoticonCaptionCard.propTypes = {
  timeout: PropTypes.number,
  subTitle: PropTypes.string,
  image: PropTypes.node,
  radius: PropTypes.radius
}

EmoticonCaptionCard.defaultProps = {
  timeout: 0
}

export default EmoticonCaptionCard
